export default __webpack_public_path__ + "media/images/admin/car-with-check-89793612d566a6196e9247627d9a8a39.svg";